import { UpdateMode } from '../components/summary/summary.types';

export const FormMode = {
  TICKETING: 'ticketing',
  FORM: 'form',
  SUMMARY: 'summary',
  UPDATE_SUMMARY: 'summary-with-update',
  CONFIRMATION: 'confirmation',
};

type UpdateData = { options?: { updateMode?: { mode?: string } }; isUpdate?: boolean };

/**
 * A participant coming back first sees a summary, or the form itself in the `form` update mode.
 * The back-office preview asks it of the options it sends instead of the loaded ones.
 */
export function isUpdateWithSummary(data: UpdateData = window.__DATA__): boolean {
  const { options, isUpdate } = data || {};
  const { updateMode } = options || {};
  return (
    !!isUpdate &&
    (updateMode?.mode === UpdateMode.SummaryWithUpdate ||
      updateMode?.mode === UpdateMode.SummaryOnly ||
      updateMode?.mode === UpdateMode.UpdateButtonWithoutSummary)
  );
}
